var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Online_Devices"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Online_Devices",
    "data-name": "Online Devices",
    clipPath: "url(#clip-Online_Devices)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43275",
    "data-name": "Group 43275",
    transform: "translate(-22449 5486)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_951",
    "data-name": "Ellipse 951",
    cx: 145,
    cy: 145,
    r: 145,
    transform: "translate(22454 -5481)",
    fill: "#24a329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wifi_FILL0_wght200_GRAD0_opsz48",
    d: "M88.812-655.624a4.865,4.865,0,0,1-1.532-3.417,4.479,4.479,0,0,1,1.371-3.538,80.146,80.146,0,0,1,24.316-16.744,70.092,70.092,0,0,1,28.246-5.7,70.091,70.091,0,0,1,28.246,5.7,80.145,80.145,0,0,1,24.316,16.744,4.5,4.5,0,0,1,1.315,3.341,5.137,5.137,0,0,1-1.476,3.614,4.355,4.355,0,0,1-3.256,1.525,3.62,3.62,0,0,1-2.983-1.474,74.254,74.254,0,0,0-21.935-14.594,61.642,61.642,0,0,0-24.228-4.917,61.641,61.641,0,0,0-24.228,4.917,74.254,74.254,0,0,0-21.935,14.594,4.557,4.557,0,0,1-3.064,1.388A3.991,3.991,0,0,1,88.812-655.624Zm-35.4-37.8a4.719,4.719,0,0,1-1.451-3.529,4.338,4.338,0,0,1,1.451-3.478A136.438,136.438,0,0,1,93.135-728.15a113.375,113.375,0,0,1,48.08-10.312,113.376,113.376,0,0,1,48.08,10.312,136.443,136.443,0,0,1,39.723,27.716,4.376,4.376,0,0,1,1.476,3.452,4.7,4.7,0,0,1-1.476,3.555,4.1,4.1,0,0,1-3.28,1.438,4.663,4.663,0,0,1-3.168-1.388A129.6,129.6,0,0,0,185.164-719.2a105.222,105.222,0,0,0-43.949-9.327A105.222,105.222,0,0,0,97.265-719.2,129.6,129.6,0,0,0,59.86-693.377a4.663,4.663,0,0,1-3.168,1.388,4.1,4.1,0,0,1-3.28-1.438Zm87.8,88.9a11.972,11.972,0,0,1-9.047-4.042,13.645,13.645,0,0,1-3.785-9.661,13.644,13.644,0,0,1,3.785-9.661,11.969,11.969,0,0,1,9.047-4.043,11.969,11.969,0,0,1,9.047,4.043,13.644,13.644,0,0,1,3.785,9.661,13.645,13.645,0,0,1-3.785,9.661A11.972,11.972,0,0,1,141.214-604.526Z",
    transform: "translate(22458.057 -4663.404)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineDevices);
export default __webpack_public_path__ + "static/media/OnlineDevices.36380dc430a96fe83143f3e2b38884f2.svg";
export { ForwardRef as ReactComponent };